import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';

import { HomepageSeo } from './HomepageSeo';
import { Homepage } from './index';

type HomepagePageProps = {
  ogTime: number;
};

// Sharing this component across routes preserves trade state during navigation.
export default function HomepagePage({ ogTime }: HomepagePageProps) {
  return (
    <div className="overflow-hidden h-fit">
      <HomepageSeo ogTime={ogTime} />
      <Header isHomepage={true} hideSearch={false} />
      <Homepage />
      <div className="h-14" />
      <hr className="border-token-gray-300" />
      <Footer isHomepage={true} />
    </div>
  );
}
